import React from "react";
import { Flex, TextArea } from "../../../resourses/digitallabs/one-x-ui";
import "../../../styles/DynamicFormRenderer_Helix.css";
import { showCatchError } from "../../../utils/toastMessageUtil";
import { validateSecureInput } from "../../../utils/inputCheckUtility";

const DynamicTextArea = ({
  field,
  fieldName,
  value,
  isMain,
  step,
  fieldRefs,
  updateValue,
  renderLabelWithPrefix,
  fieldIsRequired,
  validateSingleField,
  validateVisible,
  setErrors,
  setIsValid,
  onFormValidityChange,
  submitted,
  errors,
  maxLength,
}) => {
  let disabled = !!field.default_answer;

  const safeValue = typeof value === "string" || typeof value === "number" ? value : "";

  const inputValue = field.default_answer ?? String(safeValue);

  return (
    <Flex key={fieldName} direction="column" gap="xs" className="dfh-field-wrapper" ref={(el) => (fieldRefs.current[fieldName] = el)}>
      <TextArea
        value={inputValue}
        placeholder={field.placeholder || "Enter"}
        size={field.size || "md"}
        rows={field.rows || 3}
        cols={field.cols || 30}
        label={{
          label: renderLabelWithPrefix(isMain, field.question, step),
          optional: !fieldIsRequired(field),
          infoMessage: field.info_text || undefined,
        }}
        maxLength={maxLength ?? undefined}
        disabled={disabled}
        onBlur={() => {
          if (!validateSecureInput(inputValue)) {
            showCatchError(field.question ? `Invalid input characters in ${field.question}` : "Invalid input characters");
            return;
          }

          const single = validateSingleField(field);
          setErrors((prev) => ({ ...prev, ...single }));

          const validation = validateVisible();
          const valid = Object.keys(validation).length === 0;

          setIsValid(valid);
          if (typeof onFormValidityChange === "function") {
            onFormValidityChange(valid);
          }
        }}
        onChange={(e) => {
          if (!disabled) {
            let val = e.target.value ?? "";

            // numeric rule (keep your existing logic)
            if (field.rules?.includes("numeric")) {
              val = val.replace(/[^0-9]/g, "");
            }

            // Capitalize first character
            if (val.length > 0) {
              val = val.charAt(0).toUpperCase() + val.slice(1);
            }

            updateValue(fieldName, val);
          }
        }}
        error={submitted && errors[fieldName] ? errors[fieldName] : false}
        helperText={submitted && errors[fieldName] ? { message: errors[fieldName], status: "error" } : undefined}
      />

      {field.info_text && <div className="dfh-info-text">{field.info_text}</div>}
    </Flex>
  );
};

export default DynamicTextArea;
